module.exports = __webpack_public_path__ + "static/assets/4b53f3366e32e275cf2125dceb7b9c80.svg";